export const messages = {
  errors: {
    shortRecording: "録音時間が短すぎます。1秒以上録音してください。",
    recordingDataNotFound: "録音データが取得できませんでした。",
    recordingDataEmpty: "録音データが空です。もう一度お試しください。",
    recordingDataTooSmall: "録音データが小さすぎます。もう一度お試しください。",
    backendUrlNotSet:
      "バックエンドURLが設定されていません。VITE_API_BASE_URLまたはVITE_API_URLを設定してください。",
    transcriptionEmpty: "文字起こし結果が空でした。",
    transcriptionFailed:
      "音声の文字起こしに失敗しました。もう一度お試しください。",
    recordingStartFailed: "録音の開始に失敗しました。もう一度お試しください。",
    apiRequestFailed: "APIリクエストに失敗しました",
    timeout: "リクエストがタイムアウトしました。もう一度お試しください。",
    unknown: "音声の文字起こしに失敗しました",
    apiKeyNotSet: "APIキーが設定されていません。",
    authTokenInvalid: "認証トークンが無効です。",
    authTokenNotFound: "認証トークンが見つかりませんでした。",
  },
  ui: {
    sending: "送信中...",
    placeholder: "質問を入力してください",
    dragAndDrop: "ここにドラッグ&ドロップ",
    closeError: "エラーを閉じる",
    send: "送信",
    cancelSend: "送信を停止",
    micPermissionRequired: "マイクの使用許可が必要です",
    cancelRecording: "録音をキャンセル",
    confirmRecording: "録音を確定",
    stopRecording: "録音を停止",
    preparingVoiceInput: "音声入力を準備中...",
    transcribing: "文字起こし中...",
    voiceInput: "音声入力（Whisper）",
  },
  aria: {
    micButton: {
      recording: "録音中。クリックしてキャンセル",
      preparing: "音声入力を準備中",
      stopped: "音声入力開始",
      transcribing: "文字起こし処理中",
      permissionDenied: "マイクの使用許可が必要です",
      disabled: "音声入力は現在利用できません",
    },
    sendButton: {
      confirmRecording: "録音を確定して文字起こしを開始",
      enabled: "メッセージを送信",
      disabled: "メッセージを入力してください",
      sending: "送信中",
    },
    cancelButton: "送信をキャンセル",
    closeErrorButton: "エラーメッセージを閉じる",
    fileInput: "ファイルを添付",
  },
} as const;
